















import moment from "moment"

moment.locale("fr")

export default {
    "name": "StateSignalingSent",
    "props": {
        "context": {
            "type": Object
            "required": true
        }
    }
    "computed":
        "human_created_on": ()->
            result = moment(@context.created_on).fromNow()
            return result
    "mounted": ()->
        level = "default"
        now = moment()
        elapsed_days = moment.duration(now.diff(@context.created_on)).as("days")
        if elapsed_days > 2
            level = "warning"
        if elapsed_days > 5
            level = "danger"
        @$emit("state:set_level", level)
    "methods":
        "delete_state": ()->
                @$emit("state:delete_state")
}
